/**
 * Auto-generated HTML entity mappings for CommonMark compliance
 * Generated from https://html.spec.whatwg.org/entities.json
 * Generated by scripts/generate-entities.ts
 * 
 * Simple object mapping entity names to Unicode characters.
 * Stores only lowercase versions when case variants map to the same Unicode (saves ~8.8 KB).
 * Case-sensitive entities (where uppercase/lowercase differ) are stored with both keys.
 */

export const NAMED_CODES_TO_UNICODE: Record<string, string> = {
  "af":"⁡",
  "applyfunction":"⁡",
  "ic":"⁣",
  "invisiblecomma":"⁣",
  "invisibletimes":"⁢",
  "it":"⁢",
  "lrm":"‎",
  "negativemediumspace":"​",
  "negativethickspace":"​",
  "negativethinspace":"​",
  "negativeverythinspace":"​",
  "nobreak":"⁠",
  "rlm":"‏",
  "shy":"­",
  "zerowidthspace":"​",
  "zwj":"‍",
  "zwnj":"‌",
  "downbreve":"̑",
  "tdot":"⃛",
  "tripledot":"⃛",
  "dotdot":"⃜",
  "tab":"	",
  "newline":"\n",
  "emsp":" ",
  "emsp13":" ",
  "emsp14":" ",
  "ensp":" ",
  "hairsp":" ",
  "mediumspace":" ",
  "puncsp":" ",
  "thinsp":" ",
  "thinspace":" ",
  "verythinspace":" ",
  "nbsp":" ",
  "nonbreakingspace":" ",
  "numsp":" ",
  "thickspace":"  ",
  "oline":"‾",
  "overbar":"‾",
  "lowbar":"_",
  "underbar":"_",
  "dash":"‐",
  "hyphen":"‐",
  "ndash":"–",
  "mdash":"—",
  "horbar":"―",
  "comma":",",
  "semi":";",
  "bsemi":"⁏",
  "colon":":",
  "Colone":"⩴",
  "excl":"!",
  "iexcl":"¡",
  "quest":"?",
  "iquest":"¿",
  "period":".",
  "nldr":"‥",
  "hellip":"…",
  "mldr":"…",
  "centerdot":"·",
  "middot":"·",
  "apos":"'",
  "lsquo":"‘",
  "opencurlyquote":"‘",
  "closecurlyquote":"’",
  "rsquo":"’",
  "rsquor":"’",
  "lsquor":"‚",
  "sbquo":"‚",
  "lsaquo":"‹",
  "rsaquo":"›",
  "quot":"\"",
  "ldquo":"“",
  "opencurlydoublequote":"“",
  "closecurlydoublequote":"”",
  "rdquo":"”",
  "rdquor":"”",
  "bdquo":"„",
  "ldquor":"„",
  "laquo":"«",
  "raquo":"»",
  "lpar":"(",
  "rpar":")",
  "lbrack":"[",
  "lsqb":"[",
  "rbrack":"]",
  "rsqb":"]",
  "lbrace":"{",
  "lcub":"{",
  "rbrace":"}",
  "rcub":"}",
  "lceil":"⌈",
  "leftceiling":"⌈",
  "rceil":"⌉",
  "rightceiling":"⌉",
  "leftfloor":"⌊",
  "lfloor":"⌊",
  "rfloor":"⌋",
  "rightfloor":"⌋",
  "lopar":"⦅",
  "ropar":"⦆",
  "lbrke":"⦋",
  "rbrke":"⦌",
  "lbrkslu":"⦍",
  "rbrksld":"⦎",
  "lbrksld":"⦏",
  "rbrkslu":"⦐",
  "langd":"⦑",
  "rangd":"⦒",
  "lparlt":"⦓",
  "rpargt":"⦔",
  "gtlpar":"⦕",
  "ltrpar":"⦖",
  "leftdoublebracket":"⟦",
  "lobrk":"⟦",
  "rightdoublebracket":"⟧",
  "robrk":"⟧",
  "lang":"⟨",
  "langle":"⟨",
  "leftanglebracket":"⟨",
  "rang":"⟩",
  "rangle":"⟩",
  "rightanglebracket":"⟩",
  "Lang":"⟪",
  "Rang":"⟫",
  "loang":"⟬",
  "roang":"⟭",
  "lbbrk":"❲",
  "rbbrk":"❳",
  "Verbar":"‖",
  "Vert":"‖",
  "sect":"§",
  "para":"¶",
  "commat":"@",
  "ast":"*",
  "midast":"*",
  "sol":"/",
  "bsol":"\\",
  "amp":"&",
  "num":"#",
  "percnt":"%",
  "permil":"‰",
  "pertenk":"‱",
  "dagger":"†",
  "Dagger":"‡",
  "ddagger":"‡",
  "bull":"•",
  "bullet":"•",
  "hybull":"⁃",
  "prime":"′",
  "Prime":"″",
  "tprime":"‴",
  "qprime":"⁗",
  "backprime":"‵",
  "bprime":"‵",
  "caret":"⁁",
  "diacriticalgrave":"`",
  "grave":"`",
  "acute":"´",
  "diacriticalacute":"´",
  "diacriticaltilde":"˜",
  "tilde":"˜",
  "hat":"^",
  "macr":"¯",
  "strns":"¯",
  "breve":"˘",
  "diacriticaldot":"˙",
  "dot":"˙",
  "die":"¨",
  "Dot":"¨",
  "doubledot":"¨",
  "uml":"¨",
  "ring":"˚",
  "dblac":"˝",
  "diacriticaldoubleacute":"˝",
  "cedil":"¸",
  "cedilla":"¸",
  "ogon":"˛",
  "circ":"ˆ",
  "caron":"ˇ",
  "hacek":"ˇ",
  "deg":"°",
  "copy":"©",
  "circledr":"®",
  "reg":"®",
  "copysr":"℗",
  "weierp":"℘",
  "wp":"℘",
  "rx":"℞",
  "mho":"℧",
  "iiota":"℩",
  "larr":"←",
  "leftarrow":"←",
  "shortleftarrow":"←",
  "slarr":"←",
  "nlarr":"↚",
  "nleftarrow":"↚",
  "rarr":"→",
  "rightarrow":"→",
  "shortrightarrow":"→",
  "srarr":"→",
  "nrarr":"↛",
  "nrightarrow":"↛",
  "shortuparrow":"↑",
  "uarr":"↑",
  "uparrow":"↑",
  "darr":"↓",
  "downarrow":"↓",
  "shortdownarrow":"↓",
  "harr":"↔",
  "leftrightarrow":"↔",
  "nharr":"↮",
  "nleftrightarrow":"↮",
  "updownarrow":"↕",
  "varr":"↕",
  "nwarr":"↖",
  "nwarrow":"↖",
  "upperleftarrow":"↖",
  "nearr":"↗",
  "nearrow":"↗",
  "upperrightarrow":"↗",
  "lowerrightarrow":"↘",
  "searr":"↘",
  "searrow":"↘",
  "lowerleftarrow":"↙",
  "swarr":"↙",
  "swarrow":"↙",
  "rarrw":"↝",
  "rightsquigarrow":"↝",
  "nrarrw":"↝̸",
  "Larr":"↞",
  "twoheadleftarrow":"↞",
  "Uarr":"↟",
  "Rarr":"↠",
  "twoheadrightarrow":"↠",
  "Darr":"↡",
  "larrtl":"↢",
  "leftarrowtail":"↢",
  "rarrtl":"↣",
  "rightarrowtail":"↣",
  "leftteearrow":"↤",
  "mapstoleft":"↤",
  "mapstoup":"↥",
  "upteearrow":"↥",
  "map":"↦",
  "mapsto":"↦",
  "rightteearrow":"↦",
  "downteearrow":"↧",
  "mapstodown":"↧",
  "hookleftarrow":"↩",
  "larrhk":"↩",
  "hookrightarrow":"↪",
  "rarrhk":"↪",
  "larrlp":"↫",
  "looparrowleft":"↫",
  "looparrowright":"↬",
  "rarrlp":"↬",
  "harrw":"↭",
  "leftrightsquigarrow":"↭",
  "lsh":"↰",
  "rsh":"↱",
  "ldsh":"↲",
  "rdsh":"↳",
  "crarr":"↵",
  "cularr":"↶",
  "curvearrowleft":"↶",
  "curarr":"↷",
  "curvearrowright":"↷",
  "circlearrowleft":"↺",
  "olarr":"↺",
  "circlearrowright":"↻",
  "orarr":"↻",
  "leftharpoonup":"↼",
  "leftvector":"↼",
  "lharu":"↼",
  "downleftvector":"↽",
  "leftharpoondown":"↽",
  "lhard":"↽",
  "rightupvector":"↾",
  "uharr":"↾",
  "upharpoonright":"↾",
  "leftupvector":"↿",
  "uharl":"↿",
  "upharpoonleft":"↿",
  "rharu":"⇀",
  "rightharpoonup":"⇀",
  "rightvector":"⇀",
  "downrightvector":"⇁",
  "rhard":"⇁",
  "rightharpoondown":"⇁",
  "dharr":"⇂",
  "downharpoonright":"⇂",
  "rightdownvector":"⇂",
  "dharl":"⇃",
  "downharpoonleft":"⇃",
  "leftdownvector":"⇃",
  "rightarrowleftarrow":"⇄",
  "rightleftarrows":"⇄",
  "rlarr":"⇄",
  "udarr":"⇅",
  "uparrowdownarrow":"⇅",
  "leftarrowrightarrow":"⇆",
  "leftrightarrows":"⇆",
  "lrarr":"⇆",
  "leftleftarrows":"⇇",
  "llarr":"⇇",
  "upuparrows":"⇈",
  "uuarr":"⇈",
  "rightrightarrows":"⇉",
  "rrarr":"⇉",
  "ddarr":"⇊",
  "downdownarrows":"⇊",
  "leftrightharpoons":"⇋",
  "lrhar":"⇋",
  "reverseequilibrium":"⇋",
  "equilibrium":"⇌",
  "rightleftharpoons":"⇌",
  "rlhar":"⇌",
  "doubleleftarrow":"⇐",
  "lArr":"⇐",
  "Leftarrow":"⇐",
  "nlArr":"⇍",
  "nLeftarrow":"⇍",
  "doubleuparrow":"⇑",
  "uArr":"⇑",
  "Uparrow":"⇑",
  "doublerightarrow":"⇒",
  "implies":"⇒",
  "rArr":"⇒",
  "Rightarrow":"⇒",
  "nrArr":"⇏",
  "nRightarrow":"⇏",
  "dArr":"⇓",
  "doubledownarrow":"⇓",
  "Downarrow":"⇓",
  "doubleleftrightarrow":"⇔",
  "hArr":"⇔",
  "iff":"⇔",
  "Leftrightarrow":"⇔",
  "nhArr":"⇎",
  "nLeftrightarrow":"⇎",
  "doubleupdownarrow":"⇕",
  "Updownarrow":"⇕",
  "vArr":"⇕",
  "nwArr":"⇖",
  "neArr":"⇗",
  "seArr":"⇘",
  "swArr":"⇙",
  "laarr":"⇚",
  "lleftarrow":"⇚",
  "raarr":"⇛",
  "rrightarrow":"⇛",
  "zigrarr":"⇝",
  "larrb":"⇤",
  "leftarrowbar":"⇤",
  "rarrb":"⇥",
  "rightarrowbar":"⇥",
  "downarrowuparrow":"⇵",
  "duarr":"⇵",
  "loarr":"⇽",
  "roarr":"⇾",
  "hoarr":"⇿",
  "forall":"∀",
  "comp":"∁",
  "complement":"∁",
  "part":"∂",
  "partiald":"∂",
  "npart":"∂̸",
  "exist":"∃",
  "exists":"∃",
  "nexist":"∄",
  "nexists":"∄",
  "notexists":"∄",
  "empty":"∅",
  "emptyset":"∅",
  "emptyv":"∅",
  "varnothing":"∅",
  "del":"∇",
  "nabla":"∇",
  "element":"∈",
  "in":"∈",
  "isin":"∈",
  "isinv":"∈",
  "notelement":"∉",
  "notin":"∉",
  "notinva":"∉",
  "ni":"∋",
  "niv":"∋",
  "reverseelement":"∋",
  "suchthat":"∋",
  "notni":"∌",
  "notniva":"∌",
  "notreverseelement":"∌",
  "backepsilon":"϶",
  "bepsi":"϶",
  "prod":"∏",
  "product":"∏",
  "coprod":"∐",
  "coproduct":"∐",
  "sum":"∑",
  "plus":"+",
  "plusminus":"±",
  "plusmn":"±",
  "pm":"±",
  "div":"÷",
  "divide":"÷",
  "times":"×",
  "lt":"<",
  "nless":"≮",
  "nlt":"≮",
  "notless":"≮",
  "nvlt":"<⃒",
  "equals":"=",
  "ne":"≠",
  "notequal":"≠",
  "bne":"=⃥",
  "equal":"⩵",
  "gt":">",
  "ngt":"≯",
  "ngtr":"≯",
  "notgreater":"≯",
  "nvgt":">⃒",
  "not":"¬",
  "verbar":"|",
  "vert":"|",
  "verticalline":"|",
  "brvbar":"¦",
  "minus":"−",
  "minusplus":"∓",
  "mnplus":"∓",
  "mp":"∓",
  "dotplus":"∔",
  "plusdo":"∔",
  "frasl":"⁄",
  "backslash":"∖",
  "setminus":"∖",
  "setmn":"∖",
  "smallsetminus":"∖",
  "ssetmn":"∖",
  "lowast":"∗",
  "compfn":"∘",
  "smallcircle":"∘",
  "radic":"√",
  "sqrt":"√",
  "prop":"∝",
  "proportional":"∝",
  "propto":"∝",
  "varpropto":"∝",
  "vprop":"∝",
  "infin":"∞",
  "angrt":"∟",
  "ang":"∠",
  "angle":"∠",
  "nang":"∠⃒",
  "angmsd":"∡",
  "measuredangle":"∡",
  "angsph":"∢",
  "mid":"∣",
  "shortmid":"∣",
  "smid":"∣",
  "verticalbar":"∣",
  "nmid":"∤",
  "notverticalbar":"∤",
  "nshortmid":"∤",
  "nsmid":"∤",
  "doubleverticalbar":"∥",
  "par":"∥",
  "parallel":"∥",
  "shortparallel":"∥",
  "spar":"∥",
  "notdoubleverticalbar":"∦",
  "npar":"∦",
  "nparallel":"∦",
  "nshortparallel":"∦",
  "nspar":"∦",
  "and":"∧",
  "wedge":"∧",
  "or":"∨",
  "vee":"∨",
  "cap":"∩",
  "caps":"∩︀",
  "cup":"∪",
  "cups":"∪︀",
  "int":"∫",
  "integral":"∫",
  "Int":"∬",
  "iiint":"∭",
  "tint":"∭",
  "iiiint":"⨌",
  "qint":"⨌",
  "conint":"∮",
  "contourintegral":"∮",
  "oint":"∮",
  "Conint":"∯",
  "doublecontourintegral":"∯",
  "cconint":"∰",
  "cwint":"∱",
  "clockwisecontourintegral":"∲",
  "cwconint":"∲",
  "awconint":"∳",
  "counterclockwisecontourintegral":"∳",
  "there4":"∴",
  "therefore":"∴",
  "becaus":"∵",
  "because":"∵",
  "ratio":"∶",
  "Colon":"∷",
  "proportion":"∷",
  "dotminus":"∸",
  "minusd":"∸",
  "mddot":"∺",
  "homtht":"∻",
  "sim":"∼",
  "thicksim":"∼",
  "thksim":"∼",
  "Tilde":"∼",
  "nottilde":"≁",
  "nsim":"≁",
  "nvsim":"∼⃒",
  "backsim":"∽",
  "bsim":"∽",
  "race":"∽̱",
  "ac":"∾",
  "mstpos":"∾",
  "ace":"∾̳",
  "acd":"∿",
  "verticaltilde":"≀",
  "wr":"≀",
  "wreath":"≀",
  "eqsim":"≂",
  "equaltilde":"≂",
  "esim":"≂",
  "nesim":"≂̸",
  "notequaltilde":"≂̸",
  "sime":"≃",
  "simeq":"≃",
  "tildeequal":"≃",
  "nottildeequal":"≄",
  "nsime":"≄",
  "nsimeq":"≄",
  "cong":"≅",
  "tildefullequal":"≅",
  "ncong":"≇",
  "nottildefullequal":"≇",
  "simne":"≆",
  "ap":"≈",
  "approx":"≈",
  "asymp":"≈",
  "thickapprox":"≈",
  "thkap":"≈",
  "tildetilde":"≈",
  "nap":"≉",
  "napprox":"≉",
  "nottildetilde":"≉",
  "ape":"≊",
  "approxeq":"≊",
  "apid":"≋",
  "napid":"≋̸",
  "backcong":"≌",
  "bcong":"≌",
  "asympeq":"≍",
  "CupCap":"≍",
  "notcupcap":"≭",
  "nvap":"≍⃒",
  "bump":"≎",
  "Bumpeq":"≎",
  "humpdownhump":"≎",
  "nbump":"≎̸",
  "nothumpdownhump":"≎̸",
  "bumpe":"≏",
  "bumpeq":"≏",
  "humpequal":"≏",
  "nbumpe":"≏̸",
  "nothumpequal":"≏̸",
  "doteq":"≐",
  "dotequal":"≐",
  "esdot":"≐",
  "nedot":"≐̸",
  "doteqdot":"≑",
  "eDot":"≑",
  "efdot":"≒",
  "fallingdotseq":"≒",
  "erdot":"≓",
  "risingdotseq":"≓",
  "assign":"≔",
  "colone":"≔",
  "coloneq":"≔",
  "ecolon":"≕",
  "eqcolon":"≕",
  "ecir":"≖",
  "eqcirc":"≖",
  "circeq":"≗",
  "cire":"≗",
  "wedgeq":"≙",
  "veeeq":"≚",
  "triangleq":"≜",
  "trie":"≜",
  "equest":"≟",
  "questeq":"≟",
  "congruent":"≡",
  "equiv":"≡",
  "nequiv":"≢",
  "notcongruent":"≢",
  "bnequiv":"≡⃥",
  "le":"≤",
  "leq":"≤",
  "nle":"≰",
  "nleq":"≰",
  "notlessequal":"≰",
  "nvle":"≤⃒",
  "ge":"≥",
  "geq":"≥",
  "greaterequal":"≥",
  "nge":"≱",
  "ngeq":"≱",
  "notgreaterequal":"≱",
  "nvge":"≥⃒",
  "lE":"≦",
  "leqq":"≦",
  "lessfullequal":"≦",
  "nlE":"≦̸",
  "nleqq":"≦̸",
  "gE":"≧",
  "geqq":"≧",
  "greaterfullequal":"≧",
  "ngE":"≧̸",
  "ngeqq":"≧̸",
  "notgreaterfullequal":"≧̸",
  "lnE":"≨",
  "lneqq":"≨",
  "lvertneqq":"≨︀",
  "lvne":"≨︀",
  "gnE":"≩",
  "gneqq":"≩",
  "gvertneqq":"≩︀",
  "gvne":"≩︀",
  "ll":"≪",
  "Lt":"≪",
  "nestedlessless":"≪",
  "nltv":"≪̸",
  "notlessless":"≪̸",
  "nLt":"≪⃒",
  "gg":"≫",
  "Gt":"≫",
  "nestedgreatergreater":"≫",
  "ngtv":"≫̸",
  "notgreatergreater":"≫̸",
  "nGt":"≫⃒",
  "between":"≬",
  "twixt":"≬",
  "lesssim":"≲",
  "lesstilde":"≲",
  "lsim":"≲",
  "nlsim":"≴",
  "notlesstilde":"≴",
  "greatertilde":"≳",
  "gsim":"≳",
  "gtrsim":"≳",
  "ngsim":"≵",
  "notgreatertilde":"≵",
  "lessgreater":"≶",
  "lessgtr":"≶",
  "lg":"≶",
  "notlessgreater":"≸",
  "ntlg":"≸",
  "gl":"≷",
  "greaterless":"≷",
  "gtrless":"≷",
  "notgreaterless":"≹",
  "ntgl":"≹",
  "pr":"≺",
  "prec":"≺",
  "precedes":"≺",
  "notprecedes":"⊀",
  "npr":"⊀",
  "nprec":"⊀",
  "sc":"≻",
  "succ":"≻",
  "succeeds":"≻",
  "notsucceeds":"⊁",
  "nsc":"⊁",
  "nsucc":"⊁",
  "prcue":"≼",
  "preccurlyeq":"≼",
  "precedesslantequal":"≼",
  "notprecedesslantequal":"⋠",
  "nprcue":"⋠",
  "sccue":"≽",
  "succcurlyeq":"≽",
  "succeedsslantequal":"≽",
  "notsucceedsslantequal":"⋡",
  "nsccue":"⋡",
  "precedestilde":"≾",
  "precsim":"≾",
  "prsim":"≾",
  "scsim":"≿",
  "succeedstilde":"≿",
  "succsim":"≿",
  "notsucceedstilde":"≿̸",
  "sub":"⊂",
  "subset":"⊂",
  "nsub":"⊄",
  "notsubset":"⊂⃒",
  "nsubset":"⊂⃒",
  "vnsub":"⊂⃒",
  "sup":"⊃",
  "superset":"⊃",
  "supset":"⊃",
  "nsup":"⊅",
  "notsuperset":"⊃⃒",
  "nsupset":"⊃⃒",
  "vnsup":"⊃⃒",
  "sube":"⊆",
  "subseteq":"⊆",
  "subsetequal":"⊆",
  "notsubsetequal":"⊈",
  "nsube":"⊈",
  "nsubseteq":"⊈",
  "supe":"⊇",
  "supersetequal":"⊇",
  "supseteq":"⊇",
  "notsupersetequal":"⊉",
  "nsupe":"⊉",
  "nsupseteq":"⊉",
  "subne":"⊊",
  "subsetneq":"⊊",
  "varsubsetneq":"⊊︀",
  "vsubne":"⊊︀",
  "supne":"⊋",
  "supsetneq":"⊋",
  "varsupsetneq":"⊋︀",
  "vsupne":"⊋︀",
  "cupdot":"⊍",
  "unionplus":"⊎",
  "uplus":"⊎",
  "sqsub":"⊏",
  "sqsubset":"⊏",
  "squaresubset":"⊏",
  "notsquaresubset":"⊏̸",
  "sqsup":"⊐",
  "sqsupset":"⊐",
  "squaresuperset":"⊐",
  "notsquaresuperset":"⊐̸",
  "sqsube":"⊑",
  "sqsubseteq":"⊑",
  "squaresubsetequal":"⊑",
  "notsquaresubsetequal":"⋢",
  "nsqsube":"⋢",
  "sqsupe":"⊒",
  "sqsupseteq":"⊒",
  "squaresupersetequal":"⊒",
  "notsquaresupersetequal":"⋣",
  "nsqsupe":"⋣",
  "sqcap":"⊓",
  "sqcaps":"⊓︀",
  "squareintersection":"⊓",
  "sqcup":"⊔",
  "sqcups":"⊔︀",
  "squareunion":"⊔",
  "circleplus":"⊕",
  "oplus":"⊕",
  "circleminus":"⊖",
  "ominus":"⊖",
  "circletimes":"⊗",
  "otimes":"⊗",
  "osol":"⊘",
  "circledot":"⊙",
  "odot":"⊙",
  "circledcirc":"⊚",
  "ocir":"⊚",
  "circledast":"⊛",
  "oast":"⊛",
  "circleddash":"⊝",
  "odash":"⊝",
  "boxplus":"⊞",
  "plusb":"⊞",
  "boxminus":"⊟",
  "minusb":"⊟",
  "boxtimes":"⊠",
  "timesb":"⊠",
  "dotsquare":"⊡",
  "sdotb":"⊡",
  "righttee":"⊢",
  "vdash":"⊢",
  "nvdash":"⊬",
  "dashv":"⊣",
  "lefttee":"⊣",
  "downtee":"⊤",
  "top":"⊤",
  "bot":"⊥",
  "bottom":"⊥",
  "perp":"⊥",
  "uptee":"⊥",
  "models":"⊧",
  "doublerighttee":"⊨",
  "vDash":"⊨",
  "nvDash":"⊭",
  "Vdash":"⊩",
  "nVdash":"⊮",
  "vvdash":"⊪",
  "VDash":"⊫",
  "nVDash":"⊯",
  "prurel":"⊰",
  "lefttriangle":"⊲",
  "vartriangleleft":"⊲",
  "vltri":"⊲",
  "nltri":"⋪",
  "notlefttriangle":"⋪",
  "ntriangleleft":"⋪",
  "righttriangle":"⊳",
  "vartriangleright":"⊳",
  "vrtri":"⊳",
  "notrighttriangle":"⋫",
  "nrtri":"⋫",
  "ntriangleright":"⋫",
  "lefttriangleequal":"⊴",
  "ltrie":"⊴",
  "trianglelefteq":"⊴",
  "nltrie":"⋬",
  "notlefttriangleequal":"⋬",
  "ntrianglelefteq":"⋬",
  "nvltrie":"⊴⃒",
  "righttriangleequal":"⊵",
  "rtrie":"⊵",
  "trianglerighteq":"⊵",
  "notrighttriangleequal":"⋭",
  "nrtrie":"⋭",
  "ntrianglerighteq":"⋭",
  "nvrtrie":"⊵⃒",
  "origof":"⊶",
  "imof":"⊷",
  "multimap":"⊸",
  "mumap":"⊸",
  "hercon":"⊹",
  "intcal":"⊺",
  "intercal":"⊺",
  "veebar":"⊻",
  "barvee":"⊽",
  "angrtvb":"⊾",
  "lrtri":"⊿",
  "bigwedge":"⋀",
  "Wedge":"⋀",
  "xwedge":"⋀",
  "bigvee":"⋁",
  "Vee":"⋁",
  "xvee":"⋁",
  "bigcap":"⋂",
  "intersection":"⋂",
  "xcap":"⋂",
  "bigcup":"⋃",
  "union":"⋃",
  "xcup":"⋃",
  "diam":"⋄",
  "diamond":"⋄",
  "sdot":"⋅",
  "sstarf":"⋆",
  "Star":"⋆",
  "divideontimes":"⋇",
  "divonx":"⋇",
  "bowtie":"⋈",
  "ltimes":"⋉",
  "rtimes":"⋊",
  "leftthreetimes":"⋋",
  "lthree":"⋋",
  "rightthreetimes":"⋌",
  "rthree":"⋌",
  "backsimeq":"⋍",
  "bsime":"⋍",
  "curlyvee":"⋎",
  "cuvee":"⋎",
  "curlywedge":"⋏",
  "cuwed":"⋏",
  "Sub":"⋐",
  "Subset":"⋐",
  "Sup":"⋑",
  "Supset":"⋑",
  "Cap":"⋒",
  "Cup":"⋓",
  "fork":"⋔",
  "pitchfork":"⋔",
  "epar":"⋕",
  "lessdot":"⋖",
  "ltdot":"⋖",
  "gtdot":"⋗",
  "gtrdot":"⋗",
  "Ll":"⋘",
  "nll":"⋘̸",
  "Gg":"⋙",
  "ggg":"⋙",
  "ngg":"⋙̸",
  "leg":"⋚",
  "lesg":"⋚︀",
  "lesseqgtr":"⋚",
  "lessequalgreater":"⋚",
  "gel":"⋛",
  "gesl":"⋛︀",
  "greaterequalless":"⋛",
  "gtreqless":"⋛",
  "cuepr":"⋞",
  "curlyeqprec":"⋞",
  "cuesc":"⋟",
  "curlyeqsucc":"⋟",
  "lnsim":"⋦",
  "gnsim":"⋧",
  "precnsim":"⋨",
  "prnsim":"⋨",
  "scnsim":"⋩",
  "succnsim":"⋩",
  "vellip":"⋮",
  "ctdot":"⋯",
  "utdot":"⋰",
  "dtdot":"⋱",
  "disin":"⋲",
  "isinsv":"⋳",
  "isins":"⋴",
  "isindot":"⋵",
  "notindot":"⋵̸",
  "notinvc":"⋶",
  "notinvb":"⋷",
  "isine":"⋹",
  "notine":"⋹̸",
  "nisd":"⋺",
  "xnis":"⋻",
  "nis":"⋼",
  "notnivc":"⋽",
  "notnivb":"⋾",
  "barwed":"⌅",
  "barwedge":"⌅",
  "Barwed":"⌆",
  "doublebarwedge":"⌆",
  "drcrop":"⌌",
  "dlcrop":"⌍",
  "urcrop":"⌎",
  "ulcrop":"⌏",
  "bnot":"⌐",
  "profline":"⌒",
  "profsurf":"⌓",
  "telrec":"⌕",
  "target":"⌖",
  "ulcorn":"⌜",
  "ulcorner":"⌜",
  "urcorn":"⌝",
  "urcorner":"⌝",
  "dlcorn":"⌞",
  "llcorner":"⌞",
  "drcorn":"⌟",
  "lrcorner":"⌟",
  "frown":"⌢",
  "sfrown":"⌢",
  "smile":"⌣",
  "ssmile":"⌣",
  "cylcty":"⌭",
  "profalar":"⌮",
  "topbot":"⌶",
  "ovbar":"⌽",
  "solbar":"⌿",
  "angzarr":"⍼",
  "lmoust":"⎰",
  "lmoustache":"⎰",
  "rmoust":"⎱",
  "rmoustache":"⎱",
  "overbracket":"⎴",
  "tbrk":"⎴",
  "bbrk":"⎵",
  "underbracket":"⎵",
  "bbrktbrk":"⎶",
  "overparenthesis":"⏜",
  "underparenthesis":"⏝",
  "overbrace":"⏞",
  "underbrace":"⏟",
  "trpezium":"⏢",
  "elinters":"⏧",
  "blank":"␣",
  "boxh":"─",
  "horizontalline":"─",
  "boxv":"│",
  "boxdr":"┌",
  "boxdl":"┐",
  "boxur":"└",
  "boxul":"┘",
  "boxvr":"├",
  "boxvl":"┤",
  "boxhd":"┬",
  "boxhu":"┴",
  "boxvh":"┼",
  "boxH":"═",
  "boxV":"║",
  "boxdR":"╒",
  "boxDr":"╓",
  "boxDR":"╔",
  "boxdL":"╕",
  "boxDl":"╖",
  "boxDL":"╗",
  "boxuR":"╘",
  "boxUr":"╙",
  "boxUR":"╚",
  "boxuL":"╛",
  "boxUl":"╜",
  "boxUL":"╝",
  "boxvR":"╞",
  "boxVr":"╟",
  "boxVR":"╠",
  "boxvL":"╡",
  "boxVl":"╢",
  "boxVL":"╣",
  "boxHd":"╤",
  "boxhD":"╥",
  "boxHD":"╦",
  "boxHu":"╧",
  "boxhU":"╨",
  "boxHU":"╩",
  "boxvH":"╪",
  "boxVh":"╫",
  "boxVH":"╬",
  "uhblk":"▀",
  "lhblk":"▄",
  "block":"█",
  "blk14":"░",
  "blk12":"▒",
  "blk34":"▓",
  "squ":"□",
  "square":"□",
  "blacksquare":"▪",
  "filledverysmallsquare":"▪",
  "squarf":"▪",
  "squf":"▪",
  "emptyverysmallsquare":"▫",
  "rect":"▭",
  "marker":"▮",
  "fltns":"▱",
  "bigtriangleup":"△",
  "xutri":"△",
  "blacktriangle":"▴",
  "utrif":"▴",
  "triangle":"▵",
  "utri":"▵",
  "blacktriangleright":"▸",
  "rtrif":"▸",
  "rtri":"▹",
  "triangleright":"▹",
  "bigtriangledown":"▽",
  "xdtri":"▽",
  "blacktriangledown":"▾",
  "dtrif":"▾",
  "dtri":"▿",
  "triangledown":"▿",
  "blacktriangleleft":"◂",
  "ltrif":"◂",
  "ltri":"◃",
  "triangleleft":"◃",
  "loz":"◊",
  "lozenge":"◊",
  "cir":"○",
  "tridot":"◬",
  "bigcirc":"◯",
  "xcirc":"◯",
  "ultri":"◸",
  "urtri":"◹",
  "lltri":"◺",
  "emptysmallsquare":"◻",
  "filledsmallsquare":"◼",
  "bigstar":"★",
  "starf":"★",
  "star":"☆",
  "phone":"☎",
  "female":"♀",
  "male":"♂",
  "spades":"♠",
  "spadesuit":"♠",
  "clubs":"♣",
  "clubsuit":"♣",
  "hearts":"♥",
  "heartsuit":"♥",
  "diamondsuit":"♦",
  "diams":"♦",
  "sung":"♪",
  "check":"✓",
  "checkmark":"✓",
  "cross":"✗",
  "malt":"✠",
  "maltese":"✠",
  "sext":"✶",
  "verticalseparator":"❘",
  "bsolhsub":"⟈",
  "suphsol":"⟉",
  "longleftarrow":"⟵",
  "xlarr":"⟵",
  "longrightarrow":"⟶",
  "xrarr":"⟶",
  "longleftrightarrow":"⟷",
  "xharr":"⟷",
  "doublelongleftarrow":"⟸",
  "Longleftarrow":"⟸",
  "xlArr":"⟸",
  "doublelongrightarrow":"⟹",
  "Longrightarrow":"⟹",
  "xrArr":"⟹",
  "doublelongleftrightarrow":"⟺",
  "Longleftrightarrow":"⟺",
  "xhArr":"⟺",
  "longmapsto":"⟼",
  "xmap":"⟼",
  "dzigrarr":"⟿",
  "nvlarr":"⤂",
  "nvrarr":"⤃",
  "nvharr":"⤄",
  "Map":"⤅",
  "lbarr":"⤌",
  "bkarow":"⤍",
  "lBarr":"⤎",
  "dbkarow":"⤏",
  "rBarr":"⤏",
  "drbkarow":"⤐",
  "rbarr":"⤐",
  "RBarr":"⤐",
  "ddotrahd":"⤑",
  "uparrowbar":"⤒",
  "downarrowbar":"⤓",
  "Rarrtl":"⤖",
  "latail":"⤙",
  "ratail":"⤚",
  "lAtail":"⤛",
  "rAtail":"⤜",
  "larrfs":"⤝",
  "rarrfs":"⤞",
  "larrbfs":"⤟",
  "rarrbfs":"⤠",
  "nwarhk":"⤣",
  "nearhk":"⤤",
  "hksearow":"⤥",
  "searhk":"⤥",
  "hkswarow":"⤦",
  "swarhk":"⤦",
  "nwnear":"⤧",
  "nesear":"⤨",
  "toea":"⤨",
  "seswar":"⤩",
  "tosa":"⤩",
  "swnwar":"⤪",
  "rarrc":"⤳",
  "nrarrc":"⤳̸",
  "cudarrr":"⤵",
  "ldca":"⤶",
  "rdca":"⤷",
  "cudarrl":"⤸",
  "larrpl":"⤹",
  "curarrm":"⤼",
  "cularrp":"⤽",
  "rarrpl":"⥅",
  "harrcir":"⥈",
  "uarrocir":"⥉",
  "lurdshar":"⥊",
  "ldrushar":"⥋",
  "leftrightvector":"⥎",
  "rightupdownvector":"⥏",
  "downleftrightvector":"⥐",
  "leftupdownvector":"⥑",
  "leftvectorbar":"⥒",
  "rightvectorbar":"⥓",
  "rightupvectorbar":"⥔",
  "rightdownvectorbar":"⥕",
  "downleftvectorbar":"⥖",
  "downrightvectorbar":"⥗",
  "leftupvectorbar":"⥘",
  "leftdownvectorbar":"⥙",
  "leftteevector":"⥚",
  "rightteevector":"⥛",
  "rightupteevector":"⥜",
  "rightdownteevector":"⥝",
  "downleftteevector":"⥞",
  "downrightteevector":"⥟",
  "leftupteevector":"⥠",
  "leftdownteevector":"⥡",
  "lhar":"⥢",
  "uhar":"⥣",
  "rhar":"⥤",
  "dhar":"⥥",
  "luruhar":"⥦",
  "ldrdhar":"⥧",
  "ruluhar":"⥨",
  "rdldhar":"⥩",
  "lharul":"⥪",
  "llhard":"⥫",
  "rharul":"⥬",
  "lrhard":"⥭",
  "udhar":"⥮",
  "upequilibrium":"⥮",
  "duhar":"⥯",
  "reverseupequilibrium":"⥯",
  "roundimplies":"⥰",
  "erarr":"⥱",
  "simrarr":"⥲",
  "larrsim":"⥳",
  "rarrsim":"⥴",
  "rarrap":"⥵",
  "ltlarr":"⥶",
  "gtrarr":"⥸",
  "subrarr":"⥹",
  "suplarr":"⥻",
  "lfisht":"⥼",
  "rfisht":"⥽",
  "ufisht":"⥾",
  "dfisht":"⥿",
  "vzigzag":"⦚",
  "vangrt":"⦜",
  "angrtvbd":"⦝",
  "ange":"⦤",
  "range":"⦥",
  "dwangle":"⦦",
  "uwangle":"⦧",
  "angmsdaa":"⦨",
  "angmsdab":"⦩",
  "angmsdac":"⦪",
  "angmsdad":"⦫",
  "angmsdae":"⦬",
  "angmsdaf":"⦭",
  "angmsdag":"⦮",
  "angmsdah":"⦯",
  "bemptyv":"⦰",
  "demptyv":"⦱",
  "cemptyv":"⦲",
  "raemptyv":"⦳",
  "laemptyv":"⦴",
  "ohbar":"⦵",
  "omid":"⦶",
  "opar":"⦷",
  "operp":"⦹",
  "olcross":"⦻",
  "odsold":"⦼",
  "olcir":"⦾",
  "ofcir":"⦿",
  "olt":"⧀",
  "ogt":"⧁",
  "cirscir":"⧂",
  "cirE":"⧃",
  "solb":"⧄",
  "bsolb":"⧅",
  "boxbox":"⧉",
  "trisb":"⧍",
  "rtriltri":"⧎",
  "lefttrianglebar":"⧏",
  "notlefttrianglebar":"⧏̸",
  "righttrianglebar":"⧐",
  "notrighttrianglebar":"⧐̸",
  "iinfin":"⧜",
  "infintie":"⧝",
  "nvinfin":"⧞",
  "eparsl":"⧣",
  "smeparsl":"⧤",
  "eqvparsl":"⧥",
  "blacklozenge":"⧫",
  "lozf":"⧫",
  "ruledelayed":"⧴",
  "dsol":"⧶",
  "bigodot":"⨀",
  "xodot":"⨀",
  "bigoplus":"⨁",
  "xoplus":"⨁",
  "bigotimes":"⨂",
  "xotime":"⨂",
  "biguplus":"⨄",
  "xuplus":"⨄",
  "bigsqcup":"⨆",
  "xsqcup":"⨆",
  "fpartint":"⨍",
  "cirfnint":"⨐",
  "awint":"⨑",
  "rppolint":"⨒",
  "scpolint":"⨓",
  "npolint":"⨔",
  "pointint":"⨕",
  "quatint":"⨖",
  "intlarhk":"⨗",
  "pluscir":"⨢",
  "plusacir":"⨣",
  "simplus":"⨤",
  "plusdu":"⨥",
  "plussim":"⨦",
  "plustwo":"⨧",
  "mcomma":"⨩",
  "minusdu":"⨪",
  "loplus":"⨭",
  "roplus":"⨮",
  "Cross":"⨯",
  "timesd":"⨰",
  "timesbar":"⨱",
  "smashp":"⨳",
  "lotimes":"⨴",
  "rotimes":"⨵",
  "otimesas":"⨶",
  "Otimes":"⨷",
  "odiv":"⨸",
  "triplus":"⨹",
  "triminus":"⨺",
  "tritime":"⨻",
  "intprod":"⨼",
  "iprod":"⨼",
  "amalg":"⨿",
  "capdot":"⩀",
  "ncup":"⩂",
  "ncap":"⩃",
  "capand":"⩄",
  "cupor":"⩅",
  "cupcap":"⩆",
  "capcup":"⩇",
  "cupbrcap":"⩈",
  "capbrcup":"⩉",
  "cupcup":"⩊",
  "capcap":"⩋",
  "ccups":"⩌",
  "ccaps":"⩍",
  "ccupssm":"⩐",
  "And":"⩓",
  "Or":"⩔",
  "andand":"⩕",
  "oror":"⩖",
  "orslope":"⩗",
  "andslope":"⩘",
  "andv":"⩚",
  "orv":"⩛",
  "andd":"⩜",
  "ord":"⩝",
  "wedbar":"⩟",
  "sdote":"⩦",
  "simdot":"⩪",
  "congdot":"⩭",
  "ncongdot":"⩭̸",
  "easter":"⩮",
  "apacir":"⩯",
  "apE":"⩰",
  "nape":"⩰̸",
  "eplus":"⩱",
  "pluse":"⩲",
  "Esim":"⩳",
  "ddotseq":"⩷",
  "eddot":"⩷",
  "equivdd":"⩸",
  "ltcir":"⩹",
  "gtcir":"⩺",
  "ltquest":"⩻",
  "gtquest":"⩼",
  "leqslant":"⩽",
  "les":"⩽",
  "lessslantequal":"⩽",
  "nleqslant":"⩽̸",
  "nles":"⩽̸",
  "notlessslantequal":"⩽̸",
  "geqslant":"⩾",
  "ges":"⩾",
  "greaterslantequal":"⩾",
  "ngeqslant":"⩾̸",
  "nges":"⩾̸",
  "notgreaterslantequal":"⩾̸",
  "lesdot":"⩿",
  "gesdot":"⪀",
  "lesdoto":"⪁",
  "gesdoto":"⪂",
  "lesdotor":"⪃",
  "gesdotol":"⪄",
  "lap":"⪅",
  "lessapprox":"⪅",
  "gap":"⪆",
  "gtrapprox":"⪆",
  "lne":"⪇",
  "lneq":"⪇",
  "gne":"⪈",
  "gneq":"⪈",
  "lnap":"⪉",
  "lnapprox":"⪉",
  "gnap":"⪊",
  "gnapprox":"⪊",
  "lEg":"⪋",
  "lesseqqgtr":"⪋",
  "gEl":"⪌",
  "gtreqqless":"⪌",
  "lsime":"⪍",
  "gsime":"⪎",
  "lsimg":"⪏",
  "gsiml":"⪐",
  "lge":"⪑",
  "gle":"⪒",
  "lesges":"⪓",
  "gesles":"⪔",
  "els":"⪕",
  "eqslantless":"⪕",
  "egs":"⪖",
  "eqslantgtr":"⪖",
  "elsdot":"⪗",
  "egsdot":"⪘",
  "el":"⪙",
  "eg":"⪚",
  "siml":"⪝",
  "simg":"⪞",
  "simle":"⪟",
  "simge":"⪠",
  "lessless":"⪡",
  "notnestedlessless":"⪡̸",
  "greatergreater":"⪢",
  "notnestedgreatergreater":"⪢̸",
  "glj":"⪤",
  "gla":"⪥",
  "ltcc":"⪦",
  "gtcc":"⪧",
  "lescc":"⪨",
  "gescc":"⪩",
  "smt":"⪪",
  "lat":"⪫",
  "smte":"⪬",
  "smtes":"⪬︀",
  "late":"⪭",
  "lates":"⪭︀",
  "bumpE":"⪮",
  "pre":"⪯",
  "precedesequal":"⪯",
  "preceq":"⪯",
  "notprecedesequal":"⪯̸",
  "npre":"⪯̸",
  "npreceq":"⪯̸",
  "sce":"⪰",
  "succeedsequal":"⪰",
  "succeq":"⪰",
  "notsucceedsequal":"⪰̸",
  "nsce":"⪰̸",
  "nsucceq":"⪰̸",
  "prE":"⪳",
  "scE":"⪴",
  "precneqq":"⪵",
  "prne":"⪵",
  "scne":"⪶",
  "succneqq":"⪶",
  "prap":"⪷",
  "precapprox":"⪷",
  "scap":"⪸",
  "succapprox":"⪸",
  "precnapprox":"⪹",
  "prnap":"⪹",
  "scnap":"⪺",
  "succnapprox":"⪺",
  "Pr":"⪻",
  "Sc":"⪼",
  "subdot":"⪽",
  "supdot":"⪾",
  "subplus":"⪿",
  "supplus":"⫀",
  "submult":"⫁",
  "supmult":"⫂",
  "subedot":"⫃",
  "supedot":"⫄",
  "subE":"⫅",
  "subseteqq":"⫅",
  "nsubE":"⫅̸",
  "nsubseteqq":"⫅̸",
  "supE":"⫆",
  "supseteqq":"⫆",
  "nsupE":"⫆̸",
  "nsupseteqq":"⫆̸",
  "subsim":"⫇",
  "supsim":"⫈",
  "subnE":"⫋",
  "subsetneqq":"⫋",
  "varsubsetneqq":"⫋︀",
  "vsubnE":"⫋︀",
  "supnE":"⫌",
  "supsetneqq":"⫌",
  "varsupsetneqq":"⫌︀",
  "vsupnE":"⫌︀",
  "csub":"⫏",
  "csup":"⫐",
  "csube":"⫑",
  "csupe":"⫒",
  "subsup":"⫓",
  "supsub":"⫔",
  "subsub":"⫕",
  "supsup":"⫖",
  "suphsub":"⫗",
  "supdsub":"⫘",
  "forkv":"⫙",
  "topfork":"⫚",
  "mlcp":"⫛",
  "Dashv":"⫤",
  "doublelefttee":"⫤",
  "vdashl":"⫦",
  "barv":"⫧",
  "vbar":"⫨",
  "vbarv":"⫩",
  "Vbar":"⫫",
  "Not":"⫬",
  "bNot":"⫭",
  "rnmid":"⫮",
  "cirmid":"⫯",
  "midcir":"⫰",
  "topcir":"⫱",
  "nhpar":"⫲",
  "parsim":"⫳",
  "parsl":"⫽",
  "nparsl":"⫽⃥",
  "flat":"♭",
  "natur":"♮",
  "natural":"♮",
  "sharp":"♯",
  "curren":"¤",
  "cent":"¢",
  "dollar":"$",
  "pound":"£",
  "yen":"¥",
  "euro":"€",
  "sup1":"¹",
  "frac12":"½",
  "half":"½",
  "frac13":"⅓",
  "frac14":"¼",
  "frac15":"⅕",
  "frac16":"⅙",
  "frac18":"⅛",
  "sup2":"²",
  "frac23":"⅔",
  "frac25":"⅖",
  "sup3":"³",
  "frac34":"¾",
  "frac35":"⅗",
  "frac38":"⅜",
  "frac45":"⅘",
  "frac56":"⅚",
  "frac58":"⅝",
  "frac78":"⅞",
  "afr":"𝔞",
  "aopf":"𝕒",
  "ascr":"𝒶",
  "Afr":"𝔄",
  "Aopf":"𝔸",
  "Ascr":"𝒜",
  "ordf":"ª",
  "aacute":"á",
  "Aacute":"Á",
  "agrave":"à",
  "Agrave":"À",
  "abreve":"ă",
  "Abreve":"Ă",
  "acirc":"â",
  "Acirc":"Â",
  "aring":"å",
  "angst":"Å",
  "Aring":"Å",
  "auml":"ä",
  "Auml":"Ä",
  "atilde":"ã",
  "Atilde":"Ã",
  "aogon":"ą",
  "Aogon":"Ą",
  "amacr":"ā",
  "Amacr":"Ā",
  "aelig":"Æ",
  "AElig":"Æ",
  "bfr":"𝔟",
  "bopf":"𝕓",
  "bscr":"𝒷",
  "bernou":"ℬ",
  "bernoullis":"ℬ",
  "Bfr":"𝔅",
  "Bopf":"𝔹",
  "Bscr":"ℬ",
  "cfr":"𝔠",
  "copf":"𝕔",
  "cscr":"𝒸",
  "cayleys":"ℭ",
  "Cfr":"ℭ",
  "complexes":"ℂ",
  "Copf":"ℂ",
  "Cscr":"𝒞",
  "cacute":"ć",
  "Cacute":"Ć",
  "ccirc":"ĉ",
  "Ccirc":"Ĉ",
  "ccaron":"č",
  "Ccaron":"Č",
  "cdot":"ċ",
  "Cdot":"Ċ",
  "ccedil":"ç",
  "Ccedil":"Ç",
  "incare":"℅",
  "dfr":"𝔡",
  "differentiald":"ⅆ",
  "dopf":"𝕕",
  "dscr":"𝒹",
  "capitaldifferentiald":"ⅅ",
  "dd":"ⅅ",
  "DD":"ⅅ",
  "Dfr":"𝔇",
  "Dopf":"𝔻",
  "Dscr":"𝒟",
  "dcaron":"ď",
  "Dcaron":"Ď",
  "dstrok":"đ",
  "Dstrok":"Đ",
  "eth":"ð",
  "ETH":"Ð",
  "ee":"ⅇ",
  "efr":"𝔢",
  "eopf":"𝕖",
  "escr":"ℯ",
  "exponentiale":"ⅇ",
  "Efr":"𝔈",
  "Eopf":"𝔼",
  "Escr":"ℰ",
  "expectation":"ℰ",
  "eacute":"é",
  "Eacute":"É",
  "egrave":"è",
  "Egrave":"È",
  "ecirc":"ê",
  "Ecirc":"Ê",
  "ecaron":"ě",
  "Ecaron":"Ě",
  "euml":"ë",
  "Euml":"Ë",
  "edot":"ė",
  "Edot":"Ė",
  "eogon":"ę",
  "Eogon":"Ę",
  "emacr":"ē",
  "Emacr":"Ē",
  "ffr":"𝔣",
  "fopf":"𝕗",
  "fscr":"𝒻",
  "Ffr":"𝔉",
  "Fopf":"𝔽",
  "fouriertrf":"ℱ",
  "Fscr":"ℱ",
  "fflig":"ﬀ",
  "ffilig":"ﬃ",
  "ffllig":"ﬄ",
  "filig":"ﬁ",
  "fjlig":"fj",
  "fllig":"ﬂ",
  "fnof":"ƒ",
  "gfr":"𝔤",
  "gopf":"𝕘",
  "gscr":"ℊ",
  "Gfr":"𝔊",
  "Gopf":"𝔾",
  "Gscr":"𝒢",
  "gacute":"ǵ",
  "gbreve":"ğ",
  "Gbreve":"Ğ",
  "gcirc":"ĝ",
  "Gcirc":"Ĝ",
  "gdot":"ġ",
  "Gdot":"Ġ",
  "gcedil":"Ģ",
  "hfr":"𝔥",
  "hopf":"𝕙",
  "hscr":"𝒽",
  "planckh":"ℎ",
  "hamilt":"ℋ",
  "Hfr":"ℌ",
  "hilbertspace":"ℋ",
  "Hopf":"ℍ",
  "Hscr":"ℋ",
  "poincareplane":"ℌ",
  "quaternions":"ℍ",
  "hcirc":"ĥ",
  "Hcirc":"Ĥ",
  "hbar":"ℏ",
  "hslash":"ℏ",
  "hstrok":"ħ",
  "planck":"ℏ",
  "plankv":"ℏ",
  "Hstrok":"Ħ",
  "ifr":"𝔦",
  "ii":"ⅈ",
  "imaginaryi":"ⅈ",
  "iopf":"𝕚",
  "iscr":"𝒾",
  "Ifr":"ℑ",
  "im":"ℑ",
  "image":"ℑ",
  "imagline":"ℐ",
  "imagpart":"ℑ",
  "Iopf":"𝕀",
  "Iscr":"ℐ",
  "iacute":"í",
  "Iacute":"Í",
  "igrave":"ì",
  "Igrave":"Ì",
  "icirc":"î",
  "Icirc":"Î",
  "iuml":"ï",
  "Iuml":"Ï",
  "itilde":"ĩ",
  "Itilde":"Ĩ",
  "idot":"İ",
  "iogon":"į",
  "Iogon":"Į",
  "imacr":"ī",
  "Imacr":"Ī",
  "ijlig":"Ĳ",
  "IJlig":"Ĳ",
  "imath":"ı",
  "inodot":"ı",
  "jfr":"𝔧",
  "jopf":"𝕛",
  "jscr":"𝒿",
  "Jfr":"𝔍",
  "Jopf":"𝕁",
  "Jscr":"𝒥",
  "jcirc":"ĵ",
  "Jcirc":"Ĵ",
  "jmath":"ȷ",
  "kfr":"𝔨",
  "kopf":"𝕜",
  "kscr":"𝓀",
  "Kfr":"𝔎",
  "Kopf":"𝕂",
  "Kscr":"𝒦",
  "kcedil":"ķ",
  "Kcedil":"Ķ",
  "ell":"ℓ",
  "lfr":"𝔩",
  "lopf":"𝕝",
  "lscr":"𝓁",
  "lagran":"ℒ",
  "laplacetrf":"ℒ",
  "Lfr":"𝔏",
  "Lopf":"𝕃",
  "Lscr":"ℒ",
  "lacute":"ĺ",
  "Lacute":"Ĺ",
  "lcaron":"ľ",
  "Lcaron":"Ľ",
  "lcedil":"ļ",
  "Lcedil":"Ļ",
  "lstrok":"ł",
  "Lstrok":"Ł",
  "lmidot":"ŀ",
  "Lmidot":"Ŀ",
  "mfr":"𝔪",
  "mopf":"𝕞",
  "mscr":"𝓂",
  "mellintrf":"ℳ",
  "Mfr":"𝔐",
  "Mopf":"𝕄",
  "Mscr":"ℳ",
  "phmmat":"ℳ",
  "nfr":"𝔫",
  "nopf":"𝕟",
  "nscr":"𝓃",
  "naturals":"ℕ",
  "Nfr":"𝔑",
  "Nopf":"ℕ",
  "Nscr":"𝒩",
  "nacute":"ń",
  "Nacute":"Ń",
  "ncaron":"ň",
  "Ncaron":"Ň",
  "ntilde":"ñ",
  "Ntilde":"Ñ",
  "ncedil":"ņ",
  "Ncedil":"Ņ",
  "numero":"№",
  "eng":"ŋ",
  "ENG":"Ŋ",
  "ofr":"𝔬",
  "oopf":"𝕠",
  "order":"ℴ",
  "orderof":"ℴ",
  "oscr":"ℴ",
  "Ofr":"𝔒",
  "Oopf":"𝕆",
  "Oscr":"𝒪",
  "ordm":"º",
  "oacute":"ó",
  "Oacute":"Ó",
  "ograve":"ò",
  "Ograve":"Ò",
  "ocirc":"ô",
  "Ocirc":"Ô",
  "ouml":"ö",
  "Ouml":"Ö",
  "odblac":"ő",
  "Odblac":"Ő",
  "otilde":"õ",
  "Otilde":"Õ",
  "oslash":"ø",
  "Oslash":"Ø",
  "omacr":"ō",
  "Omacr":"Ō",
  "oelig":"Œ",
  "OElig":"Œ",
  "pfr":"𝔭",
  "popf":"𝕡",
  "pscr":"𝓅",
  "Pfr":"𝔓",
  "Popf":"ℙ",
  "primes":"ℙ",
  "Pscr":"𝒫",
  "qfr":"𝔮",
  "qopf":"𝕢",
  "qscr":"𝓆",
  "Qfr":"𝔔",
  "Qopf":"ℚ",
  "Qscr":"𝒬",
  "rationals":"ℚ",
  "kgreen":"ĸ",
  "rfr":"𝔯",
  "ropf":"𝕣",
  "rscr":"𝓇",
  "re":"ℜ",
  "real":"ℜ",
  "realine":"ℛ",
  "realpart":"ℜ",
  "reals":"ℝ",
  "Rfr":"ℜ",
  "Ropf":"ℝ",
  "Rscr":"ℛ",
  "racute":"ŕ",
  "Racute":"Ŕ",
  "rcaron":"ř",
  "Rcaron":"Ř",
  "rcedil":"ŗ",
  "Rcedil":"Ŗ",
  "sfr":"𝔰",
  "sopf":"𝕤",
  "sscr":"𝓈",
  "Sfr":"𝔖",
  "Sopf":"𝕊",
  "Sscr":"𝒮",
  "circleds":"Ⓢ",
  "os":"Ⓢ",
  "sacute":"ś",
  "Sacute":"Ś",
  "scirc":"ŝ",
  "Scirc":"Ŝ",
  "scaron":"š",
  "Scaron":"Š",
  "scedil":"ş",
  "Scedil":"Ş",
  "szlig":"ß",
  "tfr":"𝔱",
  "topf":"𝕥",
  "tscr":"𝓉",
  "Tfr":"𝔗",
  "Topf":"𝕋",
  "Tscr":"𝒯",
  "tcaron":"ť",
  "Tcaron":"Ť",
  "tcedil":"ţ",
  "Tcedil":"Ţ",
  "trade":"™",
  "tstrok":"ŧ",
  "Tstrok":"Ŧ",
  "ufr":"𝔲",
  "uopf":"𝕦",
  "uscr":"𝓊",
  "Ufr":"𝔘",
  "Uopf":"𝕌",
  "Uscr":"𝒰",
  "uacute":"ú",
  "Uacute":"Ú",
  "ugrave":"ù",
  "Ugrave":"Ù",
  "ubreve":"ŭ",
  "Ubreve":"Ŭ",
  "ucirc":"û",
  "Ucirc":"Û",
  "uring":"ů",
  "Uring":"Ů",
  "uuml":"ü",
  "Uuml":"Ü",
  "udblac":"ű",
  "Udblac":"Ű",
  "utilde":"ũ",
  "Utilde":"Ũ",
  "uogon":"ų",
  "Uogon":"Ų",
  "umacr":"ū",
  "Umacr":"Ū",
  "vfr":"𝔳",
  "vopf":"𝕧",
  "vscr":"𝓋",
  "Vfr":"𝔙",
  "Vopf":"𝕍",
  "Vscr":"𝒱",
  "wfr":"𝔴",
  "wopf":"𝕨",
  "wscr":"𝓌",
  "Wfr":"𝔚",
  "Wopf":"𝕎",
  "Wscr":"𝒲",
  "wcirc":"ŵ",
  "Wcirc":"Ŵ",
  "xfr":"𝔵",
  "xopf":"𝕩",
  "xscr":"𝓍",
  "Xfr":"𝔛",
  "Xopf":"𝕏",
  "Xscr":"𝒳",
  "yfr":"𝔶",
  "yopf":"𝕪",
  "yscr":"𝓎",
  "Yfr":"𝔜",
  "Yopf":"𝕐",
  "Yscr":"𝒴",
  "yacute":"ý",
  "Yacute":"Ý",
  "ycirc":"ŷ",
  "Ycirc":"Ŷ",
  "yuml":"ÿ",
  "Yuml":"Ÿ",
  "zfr":"𝔷",
  "zopf":"𝕫",
  "zscr":"𝓏",
  "integers":"ℤ",
  "zeetrf":"ℨ",
  "Zfr":"ℨ",
  "Zopf":"ℤ",
  "Zscr":"𝒵",
  "zacute":"ź",
  "Zacute":"Ź",
  "zcaron":"ž",
  "Zcaron":"Ž",
  "zdot":"ż",
  "Zdot":"Ż",
  "imped":"Ƶ",
  "thorn":"þ",
  "THORN":"Þ",
  "napos":"ŉ",
  "alpha":"α",
  "Alpha":"Α",
  "beta":"β",
  "Beta":"Β",
  "gamma":"γ",
  "Gamma":"Γ",
  "delta":"δ",
  "Delta":"Δ",
  "epsi":"ε",
  "epsilon":"ε",
  "epsiv":"ϵ",
  "straightepsilon":"ϵ",
  "varepsilon":"ϵ",
  "Epsilon":"Ε",
  "digamma":"ϝ",
  "gammad":"ϝ",
  "Gammad":"Ϝ",
  "zeta":"ζ",
  "Zeta":"Ζ",
  "eta":"η",
  "Eta":"Η",
  "theta":"θ",
  "thetasym":"ϑ",
  "thetav":"ϑ",
  "vartheta":"ϑ",
  "Theta":"Θ",
  "iota":"ι",
  "Iota":"Ι",
  "kappa":"κ",
  "kappav":"ϰ",
  "varkappa":"ϰ",
  "Kappa":"Κ",
  "lambda":"λ",
  "Lambda":"Λ",
  "mu":"μ",
  "micro":"µ",
  "Mu":"Μ",
  "nu":"ν",
  "Nu":"Ν",
  "xi":"ξ",
  "Xi":"Ξ",
  "omicron":"ο",
  "Omicron":"Ο",
  "pi":"π",
  "piv":"ϖ",
  "varpi":"ϖ",
  "Pi":"Π",
  "rho":"ρ",
  "rhov":"ϱ",
  "varrho":"ϱ",
  "Rho":"Ρ",
  "sigma":"σ",
  "Sigma":"Σ",
  "sigmaf":"ς",
  "sigmav":"ς",
  "varsigma":"ς",
  "tau":"τ",
  "Tau":"Τ",
  "upsi":"υ",
  "upsilon":"υ",
  "Upsilon":"Υ",
  "Upsi":"ϒ",
  "upsih":"ϒ",
  "phi":"φ",
  "phiv":"ϕ",
  "straightphi":"ϕ",
  "varphi":"ϕ",
  "Phi":"Φ",
  "chi":"χ",
  "Chi":"Χ",
  "psi":"ψ",
  "Psi":"Ψ",
  "omega":"ω",
  "ohm":"Ω",
  "Omega":"Ω",
  "acy":"а",
  "Acy":"А",
  "bcy":"б",
  "Bcy":"Б",
  "vcy":"в",
  "Vcy":"В",
  "gcy":"г",
  "Gcy":"Г",
  "gjcy":"Ѓ",
  "GJcy":"Ѓ",
  "dcy":"д",
  "Dcy":"Д",
  "djcy":"Ђ",
  "DJcy":"Ђ",
  "iecy":"Е",
  "IEcy":"Е",
  "iocy":"Ё",
  "IOcy":"Ё",
  "jukcy":"є",
  "Jukcy":"Є",
  "zhcy":"Ж",
  "ZHcy":"Ж",
  "zcy":"з",
  "Zcy":"З",
  "dscy":"Ѕ",
  "DScy":"Ѕ",
  "icy":"и",
  "Icy":"И",
  "iukcy":"і",
  "Iukcy":"І",
  "yicy":"Ї",
  "YIcy":"Ї",
  "jcy":"й",
  "Jcy":"Й",
  "jsercy":"ј",
  "Jsercy":"Ј",
  "kcy":"к",
  "Kcy":"К",
  "kjcy":"Ќ",
  "KJcy":"Ќ",
  "lcy":"л",
  "Lcy":"Л",
  "ljcy":"Љ",
  "LJcy":"Љ",
  "mcy":"м",
  "Mcy":"М",
  "ncy":"н",
  "Ncy":"Н",
  "njcy":"Њ",
  "NJcy":"Њ",
  "ocy":"о",
  "Ocy":"О",
  "pcy":"п",
  "Pcy":"П",
  "rcy":"р",
  "Rcy":"Р",
  "scy":"с",
  "Scy":"С",
  "tcy":"т",
  "Tcy":"Т",
  "tshcy":"ћ",
  "TSHcy":"Ћ",
  "ucy":"у",
  "Ucy":"У",
  "ubrcy":"ў",
  "Ubrcy":"Ў",
  "fcy":"ф",
  "Fcy":"Ф",
  "khcy":"Х",
  "KHcy":"Х",
  "tscy":"Ц",
  "TScy":"Ц",
  "chcy":"Ч",
  "CHcy":"Ч",
  "dzcy":"Џ",
  "DZcy":"Џ",
  "shcy":"Ш",
  "SHcy":"Ш",
  "shchcy":"щ",
  "SHCHcy":"Щ",
  "hardcy":"ъ",
  "HARDcy":"Ъ",
  "ycy":"ы",
  "Ycy":"Ы",
  "softcy":"ь",
  "SOFTcy":"Ь",
  "ecy":"э",
  "Ecy":"Э",
  "yucy":"Ю",
  "YUcy":"Ю",
  "yacy":"Я",
  "YAcy":"Я",
  "alefsym":"ℵ",
  "aleph":"ℵ",
  "beth":"ℶ",
  "gimel":"ℷ",
  "daleth":"ℸ"
}

/**
 * Decode a named entity using the lookup table.
 * Returns the decoded character or undefined if not found.
 * This function enables browser builds to swap in DOM-based decoding.
 */
export function decodeEntity(name: string): string | undefined {
  return NAMED_CODES_TO_UNICODE[name] || NAMED_CODES_TO_UNICODE[name.toLowerCase()]
}
